import httpV3 from "../../httpV3";

const actions = {
  emitir: async (
    state,
    {
      unidade,

      local,
      descricao,
      dataHoraInicio,
      dataHoraTermino,
    }
  ) => {
    try {
      let response = await httpV3.post("/pt", {
        unidadeId: unidade,
        local: local,
        descricao: descricao,
        dataHoraInicio: dataHoraInicio,
        dataHoraTermino: dataHoraTermino,
      });

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  adicionarCategoria: async (state, { nome, critico, unidade }) => {
    try {
      await httpV3.post(`/unidade/${unidade}/atividade`, {
        nome: nome,
        critico: critico,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  adicionarResponsavel: async (
    state,
    { tipo, nome, empresa, area, id, terceirizado, matricula }
  ) => {
    if (tipo == "Responsável pela área") {
      tipo = "responsavel_area";
    } else if (tipo == "Responsável pelas atividades") {
      tipo = "responsavel_atividades";
    }

    try {
      await httpV3.post(`/pt/${id}/responsavel`, {
        tipo: tipo,
        nome: nome,
        empresa: empresa,
        area: area,
        terceirizado: terceirizado,
        matricula: matricula,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  adicionarExecutante: async (
    state,
    { nome, empresa, area, id, matricula, terceirizado }
  ) => {
    try {
      await httpV3.post(`/pt/${id}/executante`, {
        nome: nome,
        empresa: empresa,
        area: area,
        matricula: matricula,
        terceirizado: terceirizado,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  adicionarQuestionarioEncerramento: async (state, { nome }) => {
    try {
      await httpV3.post("/questionario-encerramento", {
        questionario: nome,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  removerCategoria: async (state, { id, unidade }) => {
    try {
      await httpV3.delete(`/unidade/${unidade}/atividade/${id}`);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  removerExecutantes: async (state, { matricula, ptID }) => {
    try {
      await httpV3.delete(`/pt/${ptID}/executante/${matricula}`);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  removerResponsavel: async (state, { matricula, ptID }) => {
    try {
      await httpV3.delete(`/pt/${ptID}/responsavel/${matricula}`);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  removerQuestionario: async (
    state,
    { unidadeId, atividadeId, perguntaId }
  ) => {
    try {
      await httpV3.delete(
        `/unidade/${unidadeId}/atividade/${atividadeId}/pergunta/${perguntaId}`
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  removerQuestionarioEncerramento: async (state, { id }) => {
    try {
      await httpV3.delete(`questionario-encerramento/${id}`);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getCategoriaQuestoes: async (state, { atividadeId, ptID, resposta }) => {
    try {
      await httpV3.post(`pt/${ptID}/atividade/${atividadeId}`, {
        resposta: resposta,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  removerCategoriaQuestoes: async (state, { atividadeId, ptID, resposta }) => {
    try {
      await httpV3.delete(`pt/${ptID}/atividade/${atividadeId}`, {
        resposta: resposta,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  listarAtividadesResponder: async (state, { unidadeID }) => {
    try {
      const response = await httpV3.get(`unidade/${unidadeID}/atividade`);

      return response;
    } catch (error) {
      console.log(error);
    }
  },

  listarCategorias: async (state, { unidade = 1 }) => {
    try {
      const response = await httpV3.get(`unidade/${unidade}/atividade`);

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  listarQuestionarioEncerramento: async () => {
    try {
      const response = await httpV3.get("/questionario-encerramento");

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  listarQuestionarios: async (state, { unidade, atividade }) => {
    try {
      const response = await httpV3.get(
        `unidade/${unidade}/atividade/${atividade}`
      );

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  listarPermissoes: async () => {
    try {
      const response = await httpV3.get("/pt");

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  adicionarPergunta: async (state, { pergunta, atividadeID, unidade }) => {
    try {
      await httpV3.post(
        `unidade/${unidade}/atividade/${atividadeID}/pergunta`,
        {
          descricao: pergunta,
        }
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  finalizarPermissao: async (state, { codigo }) => {
    try {
      await httpV3.post("apiv2/auth/users", {});

      return codigo;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getPermissaoEspecifica: async (state, { permissaoID }) => {
    try {
      const response = await httpV3.get(`/pt/${permissaoID}`);

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  responderPerguntaAtividade: async (
    state,
    { ptId, atividadeId, perguntaId, resposta }
  ) => {
    try {
      const response = await httpV3.post(
        `/pt/${ptId}/atividade/${atividadeId}/pergunta/${perguntaId}`,
        {
          resposta,
        }
      );

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getUpload: async (state, { ptID }) => {
    try {
      const response = await httpV3.get(`/pt/${ptID}/assinatura/uploadUrl`);

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  finalizarEdicao: async (state, { ptId }) => {
    return await httpV3.put(`/pt/${ptId}/finalizar-edicao`);
  },
};

export const emitir = {
  namespaced: true,
  actions,
};
